import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import Home from './pages/Home';
import Iban from './pages/Iban';
import Policy from './pages/Policy';
import Privacy from './pages/Privacy';
import Shipping from './pages/Shipping';
import Terms from './pages/Terms';
import QRCode from './pages/QRCode';
import Download from './pages/Download';
import FAQPage from './pages/FAQPage';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router>
      <div className="App">
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qr-code" element={<QRCode />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/acceptable-use-policy" element={<Policy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/shipping-policy" element={<Shipping />} />
          <Route path="/users-terms-conditions" element={<Terms />} />
          <Route path="/iban" element={<Iban />} />
          <Route path="/download" element={<Download />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
